import { MutableRefObject } from 'react';
import { API, Endpoints, Project } from '@brg/api';
import { getLongreadId, getTeamLgId } from '../sections/ps-longread';
import { preparePresentationBlocks } from 'shared/modals/PresentationModeModal/utils';
import { PRESENTATION_STYLES } from 'shared/modals/PresentationModeModal/constants';

interface ScrollToSlideOptions {
  scrollToElement: (elementId: string, smooth?: boolean) => void;
  slideScrolledRef: MutableRefObject<boolean>;
  project?: Project | any;
  customLGId?: string;
  language?: string;
  initialDelay?: number;
  maxAttempts?: number;
  attemptInterval?: number;
  slideScrollDelay?: number;
}

export const createInitialScrollHandler = ({
  scrollToElement,
  slideScrolledRef,
  project,
  customLGId,
  language = 'ru',
  initialDelay = 100,
  maxAttempts = 30,
  attemptInterval = 200,
  slideScrollDelay = 300,
}: ScrollToSlideOptions) => {
  const handleInitialScroll = () => {
    setTimeout(() => {
      const hash = window.location.hash.replace('#', '');
      const slideMatch = hash.match(/slide=(\d+)/);
      
      if (slideMatch && project) {
        const slideNumber = parseInt(slideMatch[1], 10);
        if (!isNaN(slideNumber) && slideNumber > 0 && !slideScrolledRef.current) {
          slideScrolledRef.current = true;
          let attempts = 0;

          const fetchAndScrollToSlide = async () => {
            try {
              // Определяем, это лендинг или обычный проект
              // @ts-ignore
              const isTeamLG = !!project?.rootTeamId || !!project?.longreadType;
              // @ts-ignore
              const rootTeam = project?.rootTeam;
              
              const longreadId = customLGId || (isTeamLG && rootTeam 
                ? getTeamLgId(rootTeam, language) 
                : isTeamLG 
                  ? getTeamLgId(project, language)
                  : getLongreadId(project, language));
              
              if (!longreadId) {
                console.warn('[scrollHelpers] No longreadId found');
                return;
              }

              const response = await API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idLongread', longreadId)
                .get()
                .send();

              const posts = await response.json();
              const blocks = Array.isArray(posts) ? posts : [];
              
              const presentationBlocks = preparePresentationBlocks(blocks, PRESENTATION_STYLES);
              const blockIndex = slideNumber - 1;
              if (blockIndex >= 0 && blockIndex < presentationBlocks.length) {
                const targetBlock = presentationBlocks[blockIndex];
                const postId = targetBlock?.postId || targetBlock?.id;
                
                if (postId) {
                  const tryScrollToBlock = () => {
                    const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
                    if (element) {
                      scrollToElement(postId, false);
                    } else if (attempts < maxAttempts) {
                      attempts++;
                      setTimeout(tryScrollToBlock, attemptInterval);
                    }
                  };
                  
                  setTimeout(tryScrollToBlock, slideScrollDelay);
                }
              }
            } catch (err) {
              console.error('Error fetching longread blocks for scroll:', err);
            }
          };

          fetchAndScrollToSlide();
          return;
        }
      }
      
      if (hash && !hash.includes('slide=')) {
        scrollToElement(hash, false);
      }
    }, initialDelay);
  };

  return handleInitialScroll;
};

export const setupInitialScroll = (
  handleInitialScroll: () => void
): (() => void) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialScroll);
  } else {
    handleInitialScroll();
  }

  return () => {
    document.removeEventListener('DOMContentLoaded', handleInitialScroll);
  };
};
import { MutableRefObject } from 'react';
import { API, Endpoints, Project } from '@brg/api';
import { getLongreadId, getTeamLgId } from '../sections/ps-longread';
import { preparePresentationBlocks } from 'shared/modals/PresentationModeModal/utils';
import { PRESENTATION_STYLES } from 'shared/modals/PresentationModeModal/constants';

interface ScrollToSlideOptions {
  scrollToElement: (elementId: string, smooth?: boolean) => void;
  slideScrolledRef: MutableRefObject<boolean>;
  project?: Project | any;
  customLGId?: string;
  language?: string;
  initialDelay?: number;
  maxAttempts?: number;
  attemptInterval?: number;
  slideScrollDelay?: number;
}

export const createInitialScrollHandler = ({
  scrollToElement,
  slideScrolledRef,
  project,
  customLGId,
  language = 'ru',
  initialDelay = 100,
  maxAttempts = 30,
  attemptInterval = 200,
  slideScrollDelay = 300,
}: ScrollToSlideOptions) => {
  const handleInitialScroll = () => {
    setTimeout(() => {
      const hash = window.location.hash.replace('#', '');
      const slideMatch = hash.match(/slide=(\d+)/);
      
      if (slideMatch && project) {
        const slideNumber = parseInt(slideMatch[1], 10);
        if (!isNaN(slideNumber) && slideNumber > 0 && !slideScrolledRef.current) {
          slideScrolledRef.current = true;
          let attempts = 0;

          const fetchAndScrollToSlide = async () => {
            try {
              // Определяем, это лендинг или обычный проект
              // @ts-ignore
              const isTeamLG = !!project?.rootTeamId || !!project?.longreadType;
              // @ts-ignore
              const rootTeam = project?.rootTeam;
              
              const longreadId = customLGId || (isTeamLG && rootTeam 
                ? getTeamLgId(rootTeam, language) 
                : isTeamLG 
                  ? getTeamLgId(project, language)
                  : getLongreadId(project, language));
              
              if (!longreadId) {
                console.warn('[scrollHelpers] No longreadId found');
                return;
              }

              const response = await API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idLongread', longreadId)
                .get()
                .send();

              const posts = await response.json();
              const blocks = Array.isArray(posts) ? posts : [];
              
              const presentationBlocks = preparePresentationBlocks(blocks, PRESENTATION_STYLES);
              const blockIndex = slideNumber - 1;
              if (blockIndex >= 0 && blockIndex < presentationBlocks.length) {
                const targetBlock = presentationBlocks[blockIndex];
                const postId = targetBlock?.postId || targetBlock?.id;
                
                if (postId) {
                  const tryScrollToBlock = () => {
                    const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
                    if (element) {
                      scrollToElement(postId, false);
                    } else if (attempts < maxAttempts) {
                      attempts++;
                      setTimeout(tryScrollToBlock, attemptInterval);
                    }
                  };
                  
                  setTimeout(tryScrollToBlock, slideScrollDelay);
                }
              }
            } catch (err) {
              console.error('Error fetching longread blocks for scroll:', err);
            }
          };

          fetchAndScrollToSlide();
          return;
        }
      }
      
      if (hash && !hash.includes('slide=')) {
        scrollToElement(hash, false);
      }
    }, initialDelay);
  };

  return handleInitialScroll;
};

export const setupInitialScroll = (
  handleInitialScroll: () => void
): (() => void) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialScroll);
  } else {
    handleInitialScroll();
  }

  return () => {
    document.removeEventListener('DOMContentLoaded', handleInitialScroll);
  };
};
